import { render, staticRenderFns } from "./SalesLeadList.vue?vue&type=template&id=453c33a0&scoped=true&"
import script from "./SalesLeadList.vue?vue&type=script&lang=js&"
export * from "./SalesLeadList.vue?vue&type=script&lang=js&"
import style0 from "./SalesLeadList.vue?vue&type=style&index=0&id=453c33a0&lang=scss&scoped=true&"
import style1 from "./SalesLeadList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453c33a0",
  null
  
)

export default component.exports